import { render, staticRenderFns } from "./DigikalaBulkImport.vue?vue&type=template&id=2941a0f3&scoped=true"
import script from "./DigikalaBulkImport.vue?vue&type=script&lang=js"
export * from "./DigikalaBulkImport.vue?vue&type=script&lang=js"
import style0 from "./DigikalaBulkImport.vue?vue&type=style&index=0&id=2941a0f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2941a0f3",
  null
  
)

export default component.exports